import { create } from 'zustand'

type NoticeDialogState = {
  /** true lorsqu'un déclencheur manuel (ex. lien « Mes données ») demande l'ouverture. */
  manualOpen: boolean
  open: () => void
  close: () => void
}

/**
 * Permet de rouvrir la notice d'information « statistiques » depuis n'importe où
 * (menu, footer…), indépendamment de sa présentation automatique. L'apprenant doit
 * pouvoir reconsulter à tout moment l'information qui lui a été donnée (art. 13).
 */
export const useStatsNoticeDialog = create<NoticeDialogState>()(set => ({
  manualOpen: false,
  open: () => set({ manualOpen: true }),
  close: () => set({ manualOpen: false }),
}))
